import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AlertService, AuthService, IAlertType } from '../services';

export const adminGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
  const authService = inject(AuthService);
  const alertDispatcher = inject(AlertService);
  const router = inject(Router);

  if (authService.isAdmin()) {
    return of(true);
  }

  alertDispatcher.show({
    message: 'Admin-Rechte erforderlich.',
    clrAlertType: IAlertType.WARNING
  }, 4000);

  return of(router.parseUrl('/settings'));
};

